module.exports = __webpack_public_path__ + "static/media/58.5780c5bf.jpg";